<template>
  <div class="forms">
    <h2>Создать регистрационную форму</h2>
    <div class="formCardFields">
      <div class="form_cart">
        <template v-if="data && data['fields'] && data['fields'].length > 0">
          <div class="inputsDiv" v-for="(field, index) in data.fields" :key="index">
            <json-editor :value="field.label" @input="updateJsonData($event, index)"></json-editor>
            <div class="inputsForm">
              <label>{{ field.type }}</label>
              <label id="field.type">
                <input style="width: 50px;height: 30px" type="number" v-model="field.order" min="1"/>
              </label>
              <label>
                <input type="checkbox" v-model="field.enabled"/>
                Включено
              </label>
              <label>
                <input type="checkbox" v-model="field.required"/>
                Обязательный
              </label>
            </div>
          </div>
        </template>
      </div>
      <div class="form_cart">
        <div class="form_cartBanner" v-if="data">
          <img v-if="banner" :src="banner" alt="banner" class="formBanner"/>
          <img
            v-if="!banner && data.banner"
            :src="data.banner"
            alt="banner"
            class="formBanner"
          />
          <img
            v-if="!banner && !data.banner"
            src="@/assets/dummy.png"
            alt="banner"
            class="formBanner"
          />
        </div>
        <div class="form_cartBanner">
          <button
            @click="
              () => {
                $refs.banner.click();
              }
            "
          >
            Загрузить баннер
          </button>
          <input
            type="file"
            @input="fileChange"
            ref="banner"
            style="display: none"
          />
        </div>
        <div
          v-if="data && data['fields'] && data['fields'].length > 0"
          class="forCustomText"
        >
          <label for="customText">Модальный текст</label>
          <VueEditor
            id="customText"
            placeholder="Модальный текст..."
            v-model="data.custom_text"
          />
        </div>
        <div class="copyHTML">
          <!--<input type="text" value="HTML+CSS" disabled/>-->
          <button @click="copyHTML">Copy HTML, CSS, JS</button>
        </div>
        <!--<div class="copyJS">
          <input type="text" value="JS" disabled/>
          <button @click="copyJS">JS</button>
        </div>-->
        <div class="form_cartBanner">
          <button @click="updateForm">Сохранить</button>
        </div>
      </div>
    </div>
    <b-overlay :show="busy" no-wrap></b-overlay>
  </div>
</template>

<script>
import {BOverlay} from "bootstrap-vue";
import {instance} from "@/utils/composables";
import JsonEditor from "vue-json-editor";

export default {
  data: () => ({
    data: null,
    notFetched: false,
    banner: null,
    bannerImg: null,
    busy: true,
    html: null,
    customText: "",
    myArray: null,
    countryOptions: "",
  }),

  components: {
    BOverlay,
    JsonEditor,
  },

  created() {
    this.loadForms();
  },

  methods: {
    updateJsonData(newValue, index) {
      // console.log('newValue', newValue);
      // console.log('index', index);
      this.$set(this.data.fields[index], "label", newValue);
    },
    async loadForms() {
      this.busy = true;
      await this.$store.dispatch("getForms", localStorage.getItem("event"));
      this.data = this.$store.state.forms;
      // console.log(this.data);
      this.busy = false;
    },

    fileChange(e) {
      this.bannerImg = e.target.files[0];
      this.banner = URL.createObjectURL(this.bannerImg);
    },

    async copyHTML() {
      const css = `
      <style>
        @import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");

        /*@media (max-width: 1024px) {
          .banner {
            width: 750px;
          }
        }

        @media (max-width: 768px) {
          .banner {
            width: 500px;
          }
        }

        @media (max-width: 520px) {
          .banner {
            width: 100%;
          }
          .eventFormWrapper {
            max-width: 100%;
          }
        }
        }*/

        * {
          padding: 0;
          margin: 0;
          box-sizing: border-box;
        }

        body {
          background-color: rgb(233, 233, 233);
        }

        .banner {
          margin: 10px auto;
          /*width: 300px;*/
        }

        .bannerImg {
          width: 100%;
          object-fit: cover;
          /*border-radius: 10px;*/
        }

        .eventFormWrapper {
          max-width: 500px;
          margin: 10px auto;
          font-family: "Montserrat", sans-serif;
        }

        .eventFormMain {
          border-radius: 10px;
          padding: 20px;
          background-color: #fff;
        }

        .eventFormTitle {
          text-align: center;
          font-weight: 700;
          font-size: 24px;
          margin: 10px 0;
        }

        .eventFormLang {
          display: flex;
          justify-content: flex-end;
          margin-right: 45px;
        }

        .eventFormLang select {
          //display: block;
          //margin: 10px auto;
          text-align: center;
          padding: 8px;
          border-radius: 5px;
          border: 1px solid #999;
          background-color: #354b9c;
          color: #ffffff;
        }

        .eventFormMainInput {
          width: 80%;
          margin: 20px auto;
          display: flex;
          flex-direction: column;
        }

        .eventFormMainInput > input, select {
          border-radius: 10px;
          padding: 14px 20px 14px 20px;
          border: 1px solid #999;
        }

        .eventFormMainInput > label {
          margin-bottom: 5px;
          font-size: 18px;
        }

        .eventFormMainInput button#submitBtn {
          padding: 15px;
          border-radius: 10px;
          text-transform: uppercase;
          letter-spacing: 2px;
          color: #fff;
          border: none;
          background-color: #354b9c;
        }

        .imgData {
          object-fit: cover;
          width: 30%;
          aspect-ratio: 1/1;
          border-radius: 50%;
          overflow: hidden;
          margin: 10px auto;
        }

        .buttonSendingData {
          background: #c9c9c9;
        }

        .errorPopup, .successPopup {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          align-items: center;
          justify-content: center;
          height: 100vh;
          z-index: 999;
          display: none;
        }

        .popupContent {
          position: relative;
          z-index: 99;
          display: flex;
          flex-direction: column;
          padding: 10px 20px;
          width: 500px;
          min-height: 400px;
          background: #fff;
          border-radius: 10px;
          border:1px solid #e4e4e4;
        }

        .errorPopup > .popupContent{
            min-height: auto;
        }

        .successPopupClose, .errorPopupClose {
          position: absolute;
          height: 30px;
          width: 30px;
          right: 10px;
          top: 20px;
          cursor: pointer;
        }

        .successPopupClose::after, .errorPopupClose::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 2px;
          rotate: 45deg;
          background: #000;
          z-index: 99;
          }

        .successPopupClose::before, .errorPopupClose::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 2px;
          rotate: -45deg;
          background: #000;
          z-index: 99;
        }

        .successPopup::after, .errorPopup:after {
          content: "";
          z-index: 9;
          position: absolute;
          width: 100vw;
          height: 100vh;
          top:0;
          left: 0;
          background: rgba(0, 0, 0, 0.3);
        }

        .popupActive {
          display: flex;
        }

        .basicImg {
          margin: 10px auto;
          width: 50px;
          height: 50px;
        }

        .contentImg {
          margin: 10px auto;
        }

        .form-control {
          display: block;
          width: 100%;
          height: auto;
          padding: 10px 19px;
          font-size: 1rem;
          line-height: 1.4;
          color: #475f7b;
          background-color: #fff;
          border: 1px solid #999999;
          border-radius: 10px;
        }

        .form-control:focus {
          color: #475f7b;
          background-color: #fff;
          border-color: #000000;
          outline: 1px;
        }

        .intl-tel-input, .iti {
          width: 100%;
        }

        .conference {
          display: none;
        }

        .currencyWrapper {
          display: flex;
        }

        .currencyWrapper > .currencyDiv {
          margin-right: 1rem;
        }

        .currency {
          display: none;
        }

        .requiredInput {
          color: red;
        }
      </style>`;
      const maxFileSize = 1024 ** 2 * 2; // 2 MB
      const maxFileSizeInMB = `${maxFileSize / (1024 ** 2)}`;
      let custom_text = this.data.custom_text ? this.data.custom_text : "Спасибо за регистрацию";
      custom_text = `<h3 class="textContent" style="text-align: center; font-weight: 500">${custom_text}</h3>`;
      const plusImg = "data:image/png;base64,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";
      let fields = "";

      for (const data of this.data["fields"]) {
        // console.log("data:", data);
        if (data.enabled) {
          if (
            data["input_type"] === "select" &&
            data.type === "registration_type"
          ) {
            await this.$store.dispatch("getEventRegistrationTypes", localStorage.getItem("event"));
            const reg_types = this.$store.state.eventRegistrationTypes;
            // console.log("reg_types", reg_types);
            let reg_options = "";
            if (reg_types && reg_types.length > 0) {
              reg_types.forEach((item) => {
                if (item.is_form_enabled) {
                  reg_options += `<option value="${item.id}" data-type="${item.registration_type.type}">${item.registration_type.title.ru}</option>\n`;
                }
              });
            }

            fields += `
            <div class="eventFormMainInput">
            ${
              data.required === true
                ? `<label for="regType">${data?.label.ru}<span class="requiredInput">*</span></label>
                   <select name="regType" id="regType" data-title="event_registration_type" required>`
                : `<label for="regType">${data?.label.ru}</label>
                   <select name="regType" id="regType" data-title="event_registration_type">`
            }
              <!--<option value="">Выберите вид билета</option>-->
              <option value=""></option>
              ${reg_options}
              </select>
            </div>`;
          } else if (
            data["input_type"] === "select" &&
            data.type === "country"
          ) {
            fields += `
            <div class="eventFormMainInput">
            ${data.required === true
              ? `<label for="${data.type}">${data?.label.ru}<span class="requiredInput">*</span></label>
                 <select name="${data.type}" id="${data.type}" data-title="${data.type}" required>`
              : `<label for="${data.type}">${data?.label.ru}</label>
                 <select name="${data.type}" id="${data.type}" data-title="${data.type}">`
            }
              <option value=""></option>
              ${this.countryOptions}
              </select>
            </div>`;
          } else if (data["input_type"] === "file") {
            fields += `
            <div class="eventFormMainInput">
            ${
              data.type === "image"
                ? data.required === true
                  ? `<label for="${data.type}">${data.label.ru} (jpeg/jpg/png, ${maxFileSizeInMB}mb)<span class="requiredInput">*</span></label>
                     <input id="${data.type}" type="file" class="fileInput" data-title="${data.type}" accept="image/jpeg, image/jpg, image/png" required>`
                  : `<label for="${data.type}">${data.label.ru} (jpeg/jpg/png, ${maxFileSizeInMB}mb)</label>
                     <input id="${data.type}" type="file" class="fileInput" data-title="${data.type}" accept="image/jpeg, image/jpg, image/png">`
                : data.required === true
                  ? `<label for="${data.type}">${data.label.ru} (pdf/jpeg/jpg/png, ${maxFileSizeInMB}mb)<span class="requiredInput">*</span></label>
                     <input id="${data.type}" type="file" class="fileInput" data-title="${data.type}"accept="application/pdf, image/jpeg, image/jpg, image/png" required>`
                  : `<label for="${data.type}">${data.label.ru} (pdf/jpeg/jpg/png, ${maxFileSizeInMB}mb)</label>
                     <input id="${data.type}" type="file" class="fileInput" data-title="${data.type}" accept="application/pdf, image/jpeg, image/jpg, image/png">`
            }
                <span id="${data.type}ErrorText" style="color:red; display:none; margin-top:2px; font-size:13px"></span>
            </div>
            <div id="imageWrapper" class="eventFormMainInput">
                <img class="imgData" src="${plusImg}" alt="">
            </div>`;
          } else if (
            data["input_type"] === "select" &&
            data.type === "gender"
          ) {
            fields += `
            <div class="eventFormMainInput">
            ${
              data.required === true
                ? `<label for="gender">${data?.label.ru}<span class="requiredInput">*</span></label>
                   <select name="gender" id="gender" data-title="gender" required>`
                : `<label for="gender">${data?.label.ru}</label>
                   <select name="gender" id="gender" data-title="gender">`
            }
                <option value=""></option>
                <option value="M">Мужчина</option>
                <option value="F">Женщина</option>
                </select>
            </div>`;
          } else if (
            data["input_type"] === "tel" &&
            data.type === "phone_number"
          ) {
            fields += `
            <div class="eventFormMainInput">
            ${
              data.required === true
                ? `<label for="${data.type}">${data.label.ru}<span class="requiredInput">*</span></label>
                   <input type="tel" data-title="${data.type}" id="${data.type}" class="form-control" placeholder="Введите свой номер телефона" required>`
                : `<label for="${data.type}">${data.label.ru}</label>
                   <input type="tel" data-title="${data.type}" id="${data.type}" class="form-control" placeholder="Введите свой номер телефона">`
            }
            </div>`;
          } else {
            fields += `
            <div class="eventFormMainInput">
            ${
              data.required === true
                ? `<label for="${data.type}">${data.label.ru}<span class="requiredInput">*</span></label>
                   <input id="${data.type}" type="${data["input_type"]}" data-title="${data.type}" required>`
                : `<label for="${data.type}">${data.label.ru}</label>
                   <input id="${data.type}" type="${data["input_type"]}" data-title="${data.type}">`
            }
            </div>`;
          }
        }
      }

      fields += `
      <!--<div class="eventFormMainInput conference">
        <label for="conference">Участвовать в Конференции</label>
        <select name="conference" id="conference" data-title="conference_participation">
          <option value=""></option>
          <option value="1">Да</option>
          <option value="0">Нет</option>
        </select>
      </div>-->

      <!--<div class="eventFormMainInput currency">
        <label for="currency">Выберите валюту</label>
          <div class="currencyWrapper">
            <div class="currencyDiv">
              <input type="radio" id="USD" name="currency" data-title="currency" value="USD" checked>
              <label for="USD">USD</label>
            </div>
            <div class="currencyDiv">
              <input type="radio" id="UZS" name="currency" data-title="currency" value="UZS">
              <label for="UZS">UZS</label>
            </div>
          </div>
      </div>-->

      <div class="errorPopup">
        <div class="popupContent">
            <h3 class="textContent" style="text-align: center; font-weight: 500"></h3>
            <div class="errorPopupClose"></div>
        </div>
      </div>

      <div class="successPopup">
        <div class="popupContent">
            <div class="contentImg">
              <img src="https://upload.wikimedia.org/wikipedia/commons/c/c6/Sign-check-icon.png" class="basicImg"  alt="ok">
            </div>
            ${custom_text}    
            <div class="successPopupClose"></div>
        </div>
      </div>`;

      let form = `
          <form class="eventFormWrapper">
              <div class="eventFormMain">
                  <div class="eventFormTitle" id="eventFormTitle">Регистрация</div>
                  <div class="eventFormLang">
                    <select name="lang" id="lang" data-title="lang" onchange="changeLanguage()">
                      <option value="ru">Русский</option>
                      <option value="uz">O'zbekcha</option>
                      <option value="en">English</option>
                    </select>
                  </div>

                  <div class="main">${fields}</div>

                  <div class="eventFormMainInput">
                      <input id="resetForm" type="reset" value="Reset" style="display:none" />
                      <button id="submitBtn" type="submit" class="sendData">Регистрация</button>
                  </div>
              </div>
          </form>`;

      if (this.data.banner) {
        // console.log(this.data.banner);
        form = `
          <div class="banner">
            <img src="${this.data.banner}" class="bannerImg" alt="banner for event">
          </div>
          ${form}`;
      }

      const js = this.copyJS(); // copyJS function
      const result = `
        <!DOCTYPE html>
          <html lang="en">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Регистрация</title>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/css/intlTelInput.css">
            ${css}
            <script src="https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/intlTelInput.min.js"><\/script>
          </head>
          <body>
            ${form}
            <script>${js}<\/script>
          </body>
          </html>`;

      // const result = field + css;
      await navigator.clipboard.writeText(result);
      this.$toast.success("Код скопирован. (HTML, CSS, JS)");
    },

    copyJS() {
      const API_URL = process.env.VUE_APP_API_URL;
      const js = `
        let dataImage = "";
        let dataPassportImage = null;
        const imgElement = document.querySelectorAll(".fileInput");
        const imgSrc = document.querySelectorAll(".imgData");
        const successPopupCloseEl = document.querySelector(".successPopupClose");
        const errorPopupClose = document.querySelector(".errorPopupClose");
        const resetButton = document.getElementById("resetForm");
        const submitBtn = document.getElementById("submitBtn");
        const plusImg = "data:image/png;base64,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";
        const maxFileSize = 1024 ** 2 * 2; // 2 MB
        const maxFileSizeInMB = \`$\{maxFileSize / (1024 ** 2)}\`;
        const fileSizeLimitErrorText = \`Ваш загруженный файл больше \${maxFileSizeInMB} МБ\`;
        const translations = {
          en: {
            title: "Registration",
            regType: "Registration type",
            regTypeOption: {
              "ATT": "Attendee",
              "SPE": "Speaker",
              "MOD": "Moderator",
              "GOF": "Goverment official",
              "MED": "Press",
              "ORG": "Organizer",
              "VOL": "Volunteer",
              "VIP": "VIP",
              "STF": "Staff",
              "VISIT": "Visitor",
              "EXHBT": "Exhibitor",
              "BUSINESS_REP": "Business representative",
              "PARTNER": "Partner",
              "SPONSOR": "Sponsor",
              "BLOGGER": "Blogger",
            },
            firstName: "First name",
            lastName: "Last name",
            middleName: "Middle name",
            gender: "Gender",
            genderOption: {
              "M": "Man",
              "F": "Woman"
            },
            country: "Country",
            city: "City",
            position: "Position",
            organization: "Organization",
            email: "E-mail",
            phone: "Phone",
            phonePlaceholder: "Enter your phone number",
            tgUsername: "Telegram id (@name)",
            submit: "Register"
          },
          uz: {
            title: "Roʻyxatdan oʻtish",
            regType: "Roʻyxatdan oʻtish turi",
            regTypeOption: {
              "ATT": "Ishtirokchi",
              "SPE": "Maʼruzachi",
              "MOD": "Moderator",
              "GOF": "Hukumat hodimi",
              "MED": "Matbuot",
              "ORG": "Tashkilotchi",
              "VOL": "Volonter",
              "VIP": "VIP",
              "STF": "Xodim",
              "VISIT": "Tashrif buyuruvchi",
              "EXHBT": "Ko'rgazma ishtirokchisi",
              "BUSINESS_REP": "Biznes vakili",
              "PARTNER": "Hamkor",
              "SPONSOR": "Homiy",
              "BLOGGER": "Blogger",
            },
            firstName: "Ism",
            lastName: "Familiya",
            middleName: "Sharif",
            gender: "Jins",
            genderOption: {
              "M": "Erkak",
              "F": "Ayol"
            },
            country: "Mamlakat",
            city: "Shahar",
            position: "Lavozim",
            organization: "Tashkilot",
            email: "E-mail",
            phone: "Telefon",
            phonePlaceholder: "Telefon raqamingizni kiriting",
            tgUsername: "Telegram id (@name)",
            submit: "Ro'yxatdan o'tish"
          },
          ru: {
            title: "Регистрация",
            regType: "Тип регистрации",
            regTypeOption: {
              "ATT": "Участник",
              "SPE": "Спикер",
              "MOD": "Модератор",
              "GOF": "Государственный служащий",
              "MED": "Пресса",
              "ORG": "Организатор",
              "VOL": "Волонтер",
              "VIP": "VIP",
              "STF": "Персонал",
              "VISIT": "Посетитель",
              "EXHBT": "Экспонент",
              "BUSINESS_REP": "Представитель бизнеса",
              "PARTNER": "Партнер",
              "SPONSOR": "Спонсор",
              "BLOGGER": "Блогер",
            },
            firstName: "Имя",
            lastName: "Фамилия",
            middleName: "Отчество",
            gender: "Пол",
            genderOption: {
              "M": "Мужчина",
              "F": "Женщина"
            },
            country: "Страна",
            city: "Город",
            position: "Позиция",
            organization: "Организация",
            email: "E-mail",
            phone: "Телефон",
            phonePlaceholder: "Введите свой номер телефона",
            tgUsername: "Телеграм id (@name)",
            submit: "Регистрация"
          }
        };
        
        if (successPopupCloseEl) {
          successPopupCloseEl.addEventListener("click",  () => {
            document.querySelector(".successPopup").classList.toggle("popupActive");
              resetButton.click();
              imgSrc.forEach(img => img.setAttribute("src", plusImg));
              const profiletErrorTextEl = document.getElementById("imageErrorText");
              const passportErrorTextEl = document.getElementById("passport_imageErrorText");
              if (profiletErrorTextEl) {
                profiletErrorTextEl.style.display = "none";
              }
              if (passportErrorTextEl) {
                passportErrorTextEl.style.display = "none";
              }
              submitBtn.disabled = false;
          })
        }

        if (errorPopupClose) {
          errorPopupClose.addEventListener("click", () => {
            document.querySelector(".errorPopup").classList.toggle("popupActive");
            resetButton.click();
            const profiletErrorTextEl = document.getElementById("imageErrorText");
            const passportErrorTextEl = document.getElementById("passport_imageErrorText");
            if (profiletErrorTextEl) {
              profiletErrorTextEl.style.display = "none";
            }
            if (passportErrorTextEl) {
              passportErrorTextEl.style.display = "none";
            }
            submitBtn.disabled = false;
          })
        }

        function changeLanguage(lang) {
          if (!lang) {
            lang = document.getElementById("lang").value;
          } else {
            // Set the selected option in the dropdown based on the lang parameter
            for (let option of document.getElementById("lang").options) {
              if (option.value === lang) {
                option.selected = true;
                break;
              }
            }
          }

          document.getElementById("eventFormTitle").innerText = translations[lang].title;
          if (document.querySelector('label[for="regType"]')) {
            document.querySelector('label[for="regType"]').firstChild.nodeValue = translations[lang].regType;
          }
          if (document.querySelector('label[for="first_name"]')) {
            document.querySelector('label[for="first_name"]').firstChild.nodeValue = translations[lang].firstName;
          }
          if (document.querySelector('label[for="last_name"]')) {
            document.querySelector('label[for="last_name"]').firstChild.nodeValue = translations[lang].lastName;
          }
          if (document.querySelector('label[for="middle_name"]')) {
            document.querySelector('label[for="middle_name"]').firstChild.nodeValue = translations[lang].middleName;
          }
          if (document.querySelector('label[for="gender"]')) {
            document.querySelector('label[for="gender"]').firstChild.nodeValue = translations[lang].gender
          }
          if (document.querySelector('label[for="country"]')) {
            document.querySelector('label[for="country"]').firstChild.nodeValue = translations[lang].country;
          }
          if (document.querySelector('label[for="city"]')) {
            document.querySelector('label[for="city"]').firstChild.nodeValue = translations[lang].city;
          }
          if (document.querySelector('label[for="position"]')) {
            document.querySelector('label[for="position"]').firstChild.nodeValue = translations[lang].position;
          }
          if (document.querySelector('label[for="organization"]')) {
            document.querySelector('label[for="organization"]').firstChild.nodeValue = translations[lang].organization;
          }
          if (document.querySelector('label[for="email"]')) {
            document.querySelector('label[for="email"]').firstChild.nodeValue = translations[lang].email;
          }
          if (document.querySelector('label[for="phone_number"]')) {
            document.querySelector('label[for="phone_number"]').firstChild.nodeValue = translations[lang].phone;
            document.getElementById("phone_number").placeholder = translations[lang].phonePlaceholder;
          }
          if (document.querySelector('label[for="telegram_username"]')) {
            document.querySelector('label[for="telegram_username"]').firstChild.nodeValue = translations[lang].tgUsername;
          }
          document.getElementById("submitBtn").innerText = translations[lang].submit;

          // changing gender options according to the selected language
          const genderSelect = document.getElementById("gender");
          for (let option of genderSelect?.options || []) {
            if (option.value) {
              option.text = translations[lang].genderOption[option.value];
            }
          }

          // changing registration type options according to the selected language
          const regTypeSelect = document.getElementById("regType");
          for (let option of regTypeSelect?.options || []) {
            if (option.value) {
              option.text = translations[lang].regTypeOption[option.attributes["data-type"].value];
            }
          }
        }

        function toggled(error, data) {
          const modal = document.querySelector(".successPopup");
          const modalError = document.querySelector(".errorPopup");

          if (modal && !error && data) {
            modal.classList.toggle("popupActive");
            let el = document.querySelector(".successPopup .popupContent .textContent");
            el.innerHTML = el.innerHTML.replace("{public_id}", data.public_id);
          } else {
            modalError.classList.toggle("popupActive");
            document.querySelector(".errorPopup .popupContent .textContent").innerText = error;
          }
        }

        async function getEvent() {
          try {
            const response = await fetch("${API_URL}/event/${localStorage.getItem("event")}/");
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const data = await response.json();
            // console.log("data: ", data)
            return data;
          } catch (error) {
            console.error("Error:", error);
            throw error;  // Re-throw the error to handle it outside the function
          }
        }

        if (imgElement.length > 0) {
          imgElement.forEach((item, index) => {
            item.addEventListener("input", (e) => {
             if (item.getAttribute("data-title") === "image") {
               const profiletErrorTextEl = document.getElementById("imageErrorText");
               if (e.target.files[0]?.size <= maxFileSize) {
                 dataImage = e.target.files[0];
                 profiletErrorTextEl.style.display = "none";
               } else {
                 imgSrc[index].src = plusImg;
                 dataImage = "";
                 profiletErrorTextEl.innerText = fileSizeLimitErrorText;
                 profiletErrorTextEl.style.display = "block";
               }
             } else {
               const passportErrorTextEl = document.getElementById("passport_imageErrorText");
               if (e.target.files[0]?.size <= maxFileSize) {
                dataPassportImage = e.target.files[0];
                passportErrorTextEl.style.display = "none";
               } else {
                 imgSrc[index].src = plusImg;
                 dataPassportImage = null;
                 passportErrorTextEl.innerText = fileSizeLimitErrorText;
                 passportErrorTextEl.style.display = "block";
               }
             }
              if (e.target.files[0]?.size <= maxFileSize) {
                imgSrc[index].src = URL.createObjectURL(e.target.files[0]);
              }
            })
          })
        }

        document.addEventListener("DOMContentLoaded", async function () {
          // Change language on page load
          changeLanguage("en");
          // Initialize intlTelInput
          let phoneNumberEl = document.getElementById("phone_number");
          if (phoneNumberEl !== null) {
            // iti must be a global variable
            var iti = window.intlTelInput(phoneNumberEl, {
              initialCountry: "uz",
              formatOnDisplay: true,
              strictMode: true,
              separateDialCode: true,
              // onlyCountries: ["uz"],
              utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js",
            });
          }

          try {
            const eventData = await getEvent();
            // console.log("Event data:", eventData);
            if (eventData) {
              // Get the select element
              const selectElement = document.getElementById("conference");
              if (selectElement) {
                // Create the small element
                const smallElement = document.createElement("small");
                smallElement.textContent = \`(\${eventData.conference_visitors_limit} место осталось)\`;
                smallElement.style.color = "green";
                // Insert the small element after the select element
                selectElement.insertAdjacentElement("afterend", smallElement);

                if (eventData.conference_visitors_limit <= 0) {
                  document.getElementById("conference").disabled = true;
                  smallElement.style.color = "red";
                }
              }
            }
          } catch (error) {
            console.error("Error:", error);
          }

          const regTypeEl = document.getElementById("regType");
          if (regTypeEl) {
            regTypeEl.addEventListener("change", (e) => {
              // Get the selected option element
              const selectedOption = e.target.options[e.target.selectedIndex];
              // Get the data-type attribute value of the selected option
              const dataTypeValue = selectedOption.getAttribute("data-type");
              // console.log("Selected data-type:", dataTypeValue);

              /*if (dataTypeValue === "VISIT") {
                document.querySelector(".conference").style.display = "flex";
              } else {
                document.querySelector(".conference").style.display = "none";
              }*/

              if (dataTypeValue !== null) {
                document.querySelector(".currency").style.display = "flex";
              } else {
                document.querySelector(".currency").style.display = "none";
              }
            });
          }

          document.querySelector(".eventFormWrapper").addEventListener("submit", async (e) => {
            try {
              submitBtn.disabled = true;
              document.querySelector("button.sendData").classList.add("buttonSendingData");
              e.preventDefault();

              const regLang = document.getElementById("lang").value;
              const fields = document.querySelectorAll(".main input, .main select");
              const eventId = ${localStorage.getItem("event")};
              const mainData = new FormData();
              const allTextes = [];
              const imgField = [];

              fields.forEach(i => {
                if (i.getAttribute("data-title") !== "image" &&
                  i.getAttribute("data-title") !== "passport_image" &&
                  i.getAttribute("data-title") !== null) {
                  allTextes.push(i);
                }
              });

              fields.forEach(i => {
                if (i.getAttribute("data-title") === "image" ||
                  i.getAttribute("data-title") === "passport_image") {
                  imgField.push(i);
                }
              });

              allTextes.forEach(i => {
                let key = i.getAttribute("data-title");
                let value = i.value;
                // mainData.append(key, value);
                if (key === "phone_number") {
                  value = iti.getNumber();
                  mainData.append(key, value);
                } else if (key === "currency") {
                  if (i.checked) {
                    mainData.append(key, value);
                  }
                } else {
                  mainData.append(key, value);
                }
              });

              imgField.forEach(i => {
                if (i.getAttribute("data-title") === "image") {
                   mainData.append(i.getAttribute("data-title"), dataImage);
                } else {
                  mainData.append(i.getAttribute("data-title"), dataPassportImage);
                }
              });

              mainData.append("event", eventId);
              mainData.append("registration_lang", regLang);
              const response = await fetch("${API_URL}/participant/register/", {
                method: "POST",
                headers: {},
                body: mainData,
              });

              const json_response = await response.json();

              if (response.status === 400) {
                let error = "";
                Object.entries(json_response).forEach(([key, value]) => {
                  error += \`\${key}: \${value}\\n\`;
                });
                toggled(error);
                return;
              }

              if (response.status === 201) {
                if (json_response && json_response.paymentUrl) {
                  // window.location.href = json_response.paymentUrl;
                  window.location.replace(json_response.paymentUrl);
                } else {
                  toggled(null, json_response);
                }
              }
            } catch (err) {
              e.preventDefault();
              alert(err.message);
              console.log(err);
            } finally {
              document.querySelector("button.sendData").classList.remove("buttonSendingData");
            }
        });
      });
      `;
      return js;
      // navigator.clipboard.writeText(js);
      // this.$toast.success("Код скопирован. (JavaScript)");
    },

    async updateForm() {
      try {
        this.busy = true;
        const customText = this.data.custom_text;
        const fields = this.data["fields"];
        const allData = new FormData();
        const jsoned = JSON.stringify(fields);
        if (this.bannerImg) {
          allData.append("banner", this.bannerImg);
        }
        allData.append("event", localStorage.getItem("event"));
        allData.append("id", this.data.id);
        allData.append("custom_text", customText);
        allData.append("fields", jsoned);
        const data = {
          id: this.data.id,
          main: allData,
        };
        await this.$store.dispatch("updateForm", data);
        this.$toast.success("Форма для регистрации изменена");
      } catch (err) {
        this.$toast.error(err);
      } finally {
        this.busy = false;
        window.location.reload();
      }
    },

    getCountries() {
      instance.get("/event/countries/").then(({data}) => {
        data.forEach((country) => {
          this.countryOptions += `<option value="${country.id}">${country.title.en}</option>\n`;
        });
      });
    },
  },

  mounted() {
    this.getCountries();
  },
};
</script>

<style lang="scss" scoped>
.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
}

.copyHTML {
  width: 100%;
  border-radius: 10px;
  //display: flex;
  //justify-content: flex-end;
  // margin-top: 300px;
  //background-color: rgb(240, 240, 240);

  button {
    background: #359c5e;
    padding: 10px 30px;
    width: 200px;
    border: none;
    border-radius: 10px;
    color: #fff;
  }
}

.forCustomText {
  margin: 20px 0;

  textarea {
    width: 100%;
  }
}

.copyJS {
  width: 100%;
  border-radius: 10px;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  background-color: rgb(240, 240, 240);

  button {
    background: #359c5e;
    padding: 10px 30px;
    width: 200px;
    border: none;
    border-radius: 10px;
    color: #fff;
  }

  input {
    width: 80%;
    border: none;
    padding-left: 30px;
    background: transparent;
  }
}

.formCardFields {
  display: flex;
  justify-content: space-around;

  & > div {
    width: 45%;
    margin: 10px;
    text-align: left;
  }

  margin-left: 20px;
  margin-top: 15px;
  width: 90%;
  padding: 10px 30px;
  background-color: white;
  border: 2px solid #999;
  border-radius: 30px;
}

.inputsDiv {
  border: 2px solid #999;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 5px;

  .inputsForm {
    padding: 5px;
    margin: 5px 0;
    //border: 2px solid #999;
    //border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    label {
      width: 100%;
    }

    input {
      margin: 0 5px;
      height: 20px;
      width: 20px;
    }
  }
}

.form_cartBanner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    margin-top: 20px;
    padding: 10px 30px;
    width: 100%;
    border-radius: 10px;
    border: none;
    color: white;
    background-color: #354b9c;
  }
}

.forms {
  h2 {
    margin-top: 20px;
    text-align: left;
    padding-left: 20px;
  }
}

.formBanner {
  //max-width: 250px;
  width: 100%;
  //border-radius: 20px;
  overflow: hidden;
}
</style>
